import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_file_upload = _resolveComponent("v-file-upload")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    width: "600"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_v_card, { class: "d-flex flex-column" }, {
          default: _withCtx(() => [
            _createVNode(_component_FocusLock, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-4" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dialogTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-0 pt-4 flex-grow-1 d-flex flex-column justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_file_upload, {
                      modelValue: _ctx.selectedFile,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFile) = $event)),
                      accept: _ctx.acceptTypes,
                      "show-size": true,
                      clearable: "",
                      "browse-text": _ctx.$t('lieferanten.dokument.upload.durchsuchen'),
                      "divider-text": _ctx.$t('lieferanten.dokument.upload.divider'),
                      icon: "mdi-upload",
                      title: _ctx.uploadTitle,
                      counter: true,
                      disabled: false,
                      loading: false,
                      multiple: false,
                      class: "mb-4",
                      style: {"max-width":"90%"},
                      height: "320px"
                    }, null, 8, ["modelValue", "accept", "browse-text", "divider-text", "title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "ml-4 mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      color: "primary",
                      variant: "flat",
                      class: "modalbutton mb-3",
                      disabled: !_ctx.selectedFile
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.upload')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      class: "modalbutton mb-3",
                      variant: "flat",
                      onClick: _ctx.closeDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}